import React, { useState, useEffect } from "react";

//Hooks
import useGetBeneficios from "../Hooks/useGetBeneficios";

//Componentes de Material UI
import {
    Autocomplete,
    TextField,
    List,
    ListItem,
    ListItemText,
    Box,
    CircularProgress,
    Alert,
    AlertTitle,
    Tooltip,
    IconButton,
    createFilterOptions,
    Checkbox,
    Chip
} from "@mui/material";

//Iconos
import {
    Refresh as RefreshIcon,
    CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
    CheckBox as CheckBoxIcon,
} from "@mui/icons-material";

//Filtro personalizado
const filterOptions = createFilterOptions({
    matchFrom: 'start',
    stringify: (option) => option.strCodigoRetorno,
  });

const DropdownBeneficios = ({
    id,
    value,
    name,
    onChange,
    disabled,
    error,
    helperText,
    label,
    required,
    multiple,
    multiline
}) => {
    const [options, setOptions] = useState([]);

    const { data, refreshGetData } = useGetBeneficios();

    useEffect(() => {
        if (data?.length > 0) {
            setOptions(data);
        }
    }, [data]);

    if (!data) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                <CircularProgress size={30} />
            </Box>
        );
    }

    if (data.error) {
        return (
            <Alert
                severity="error"
                action={
                    <IconButton
                        onClick={() => {
                            refreshGetData();
                        }}
                        size="large"
                    >
                        <Tooltip title="Refrescar">
                            <RefreshIcon />
                        </Tooltip>
                    </IconButton>
                }
            >
                <AlertTitle>
                    <b>{data.msg}</b>
                </AlertTitle>
                Ha ocurrido un error al obtener los datos del listado de personas
                empresarias
            </Alert>
        );
    }

    return (
        <Autocomplete
            id={id}
            value={value}
            onChange={onChange}
            options={options}
            clearText="Borrar"
            openText="Abrir" 
            closeText="Cerrar"
            noOptionsText="Valor no encontrado."
            disabled={disabled}
            fullWidth
            multiple={multiple}
            filterOptions={filterOptions}
            disableCloseOnSelect={multiple ? true : false}
            renderInput={(props) => (
                <TextField
                    label={label}
                    name={name}
                    error={error}
                    required={required}
                    helperText={helperText}
                    multiline={multiline}
                    minRows={multiline ? 2 : null}
                    {...props}
                />
            )}
            isOptionEqualToValue={(option, value) => {
                if (typeof value === "string") {
                    return option === value;
                } else {
                    return (
                        option === value ||
                        option?.strCodigoRetorno === value?.strCodigoRetorno
                    );
                }
            }}
            getOptionLabel={(option) =>
                option?.strCodigoRetorno
            }
            renderTags={(value, getTagProps) =>
                value?.map((option, index) => {
                    if (option?.strCodigoRetorno) {
                        return (
                            <Chip
                                key={index}
                                label={option?.strCodigoRetorno}
                                {...getTagProps({ index })}
                            />
                        );
                    }

                    return (
                        <Chip key={index} label={option} {...getTagProps({ index })} />
                    );
                })
            }
            renderOption={(props, option, { selected }) => (
                <List {...props} disablePadding>
                    <ListItem>
                        {multiple && (
                            <Checkbox
                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                        )}
                        <ListItemText
                            primary={option?.strCodigoRetorno}
                        />
                    </ListItem>
                </List>
            )}
        />
    );
};

export default DropdownBeneficios;